import { wrapReducer } from "@client/content/lib/helper";
import { type FailureActionData } from "@client/lib/actions";
import { Status } from "@client/types";
import { type ReduxAction } from "@client/types/ReduxAction";
import { Actions } from "./actions";
import { type ForgotPassword } from "./types";

const reducer = (state: ForgotPassword.AppState = defaultState, action: ReduxAction<any>): ForgotPassword.AppState => {
  switch (action.type) {
    case Actions.SubmitBegin: {
      return {
        ...state,
        status: Status.Saving
      };
    }
    case Actions.SubmitFailure: {
      const { error } = action.data as FailureActionData;
      return {
        ...state,
        error,
        status: Status.Failed
      };
    }
    case Actions.SubmitSuccess: {
      return {
        ...state,
        showSuccessNotification: true,
        status: Status.Ready
      };
    }
    default:
      return state;
  }
};

export const defaultState: ForgotPassword.AppState = {
  error: null,
  id: "",

  showSuccessNotification: false,
  status: Status.Ready
};
export default wrapReducer({ defaultState, reducer, previewState: defaultState });
